import { Box, Button, Container, FormControl, InputLabel, MenuItem, Select, SelectChangeEvent, Typography } from "@mui/material";
import axiosInstance from "app/axios";
import { useAppDispatch, useAppSelector } from "app/hooks";
import { AxiosResponse } from "axios";
import Header from "components/header/Header";
import HolzfinderDateInputWithoutTime from "components/inputs/HolzfinderDateInputWithoutTime";
import { getAgentList } from "features/agentList/agentListSlice";
import { selectUserRole } from "features/user/userSlice";
import { UserRoles } from "interfaces/UserRoles";
import { DateTime } from "luxon";
import { useEffect, useState } from "react";

interface fetchReportsArgument {
    start_time: string;
    end_time: string;
    agent_id?: string;
    endpoint?: UserRoles;
}

interface ReportsResponseInterface {
    data: {

    };
}
interface AgentSelectOption {
    id: string;
    company: string;
}
export default function Reports() {
    const userRole = useAppSelector(selectUserRole);
    const [dateFrom, setDateFrom] = useState<string>(DateTime.now().set({ hour: 0, minute: 0, second: 0, millisecond: 0 }).toISO())
    const [dateTo, setDateTo] = useState<string>(DateTime.now().set({ hour: 0, minute: 0, second: 0, millisecond: 0 }).toISO())
    const [selectedMenuItem, setSelectedMenuItem] = useState("")
    const dispatch = useAppDispatch();
    const [agents, setAgents] = useState<Array<AgentSelectOption>>([]);
    const [showNoAgentError, setShowNoAgentError] = useState(false)
    const [alreadyReported, setAlreadyReported] = useState(false)

    const handleGenerateReport = () => {
        if (userRole === "admin" && selectedMenuItem === "") {
            setShowNoAgentError(true)
        } else {
            setAlreadyReported(true)
            setShowNoAgentError(false)
            receiveReports(dateFrom, dateTo)
        }
    }

    const getReports = async (args: fetchReportsArgument) => {
        const response = await fetchReports({ ...args, endpoint: userRole })
        return { headers: response.headers, data: response.data };
    }
    const receiveReports = (start_time: string, end_time: string) => {
        if (userRole === "admin") {
            getReports({
                start_time: start_time,
                end_time: end_time,
                agent_id: selectedMenuItem,
                endpoint: userRole
            })
                .then((event: any) => {
                    if (event.data) {
                        handleDownload(event)
                    }
                });
        } else {
            getReports({
                start_time: start_time,
                end_time: end_time,
                endpoint: userRole
            })
                .then((event: any) => {
                    if (event.data) {
                        handleDownload(event)
                    }
                });
        }
        const handleDownload = async (res: any) => {
            const link = document.createElement("a");
            link.href = window.URL.createObjectURL(res.data);
            var contentDisposition = res.headers["content-disposition"].split(';')
            var filename = contentDisposition[2].slice(18)
            link.download = `report_${filename}`;
            link.click();
            setTimeout(() => {
                setAlreadyReported(false)
            }, 3000)
        };

    }

    function fetchReports({ start_time, end_time, agent_id, endpoint = UserRoles.Admin }: fetchReportsArgument): Promise<AxiosResponse<ReportsResponseInterface, any>> {
        return axiosInstance.get(`${endpoint}/reports`, {
            params: {
                start_time,
                end_time,
                agent_id,
            },
            responseType: "blob"
        });
    }

    const handleSelectMenu = (event: SelectChangeEvent) => {
        setSelectedMenuItem(event.target.value as string)
    }

    const receiveAgentList = () => {
        dispatch(
            getAgentList({
                items_per_page: 'unlimited',
            })
        ).then((res: any) => {
            const mappedData = res.payload.data.data.agents.map(
                (agent: any) => ({
                    id: agent.id,
                    company: agent.company,
                })
            );
            const allAgents = [{ id: "all", company: "Alle" }, ...mappedData];

            setAgents(allAgents)
        })
    };
    useEffect(() => {
        if (userRole === "admin") {
            receiveAgentList();
        }
    }, []); // This empty dependency array ensures this runs only once on mount
    return (
        <Container sx={{ pl: { lg: 12, md: 12, xs: 12 }, pt: 5 }} maxWidth="xl">
            <Header header="Reports" />
            {userRole === "admin" ? (
                <Box sx={{ mt: 5 }}>
                    <FormControl sx={{ minWidth: "30%" }}>
                        <InputLabel id="demo-simple-select-autowidth-label">Bitte auswählen</InputLabel>
                        <Select
                            labelId="demo-simple-select-autowidth-label"
                            id="demo-simple-select-autowidth"
                            value={selectedMenuItem}
                            label="Bitte auswählen"
                            onChange={handleSelectMenu}
                        >
                            {agents.map((agent: any) => (
                                <MenuItem key={agent.id} value={agent.id}>{agent.company}</MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                </Box>
            ) : null}
            {showNoAgentError ? (
                <Typography sx={{ color: "rgb(211, 47, 47)", ml: 0.5, mt: 1 }} fontSize={19} fontWeight={"bold"}>
                    Bitte wählen Sie einen Agenten aus.
                </Typography>
            ) : null}
            <Box sx={{ mt: 5, display: "flex", flexDirection: "row" }} >
                <Typography sx={{ mt: 1.5, mr: 1 }} fontSize={20} fontWeight={"bold"}>Von</Typography>
                <HolzfinderDateInputWithoutTime value={dateFrom} onChange={setDateFrom} disablePast={false} />
                <Typography sx={{ mt: 1.5, ml: 3, mr: 1 }} fontSize={20} fontWeight={"bold"}>Bis</Typography>
                <HolzfinderDateInputWithoutTime value={dateTo} onChange={setDateTo} disablePast={false} />
                <Button
                    onClick={() => {
                        handleGenerateReport()
                    }}
                    disabled={alreadyReported}
                    sx={{
                        ml: 8,
                        flexGrow: 0.2,
                        borderRadius: "26px",
                        color: "#072D26",
                        fontWeight: "bold",
                        border: "2px solid #C0D904",
                        height: "56px",
                        paddingLeft: "50px",
                        paddingRight: "50px",
                        "&:hover": { background: "#c0d904" }
                    }}>
                    Report generieren
                </Button>
            </Box>
        </Container>
    )
}